import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { environment } from '../environments/environment';
import { AnalyticsService } from './services/analytics.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FormsModule } from '@angular/forms';
import { UserManagementService } from './services/user-management.service';
import { register } from "swiper/element/bundle";
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { provideCharts, withDefaultRegisterables, } from 'ng2-charts';
import { UpdatePopupModule } from './components/update-popup/update-popup.module';
import { FloatingThreadModule } from './components/ai/floating-thread-container/floating-thread.module';
import { TourModule } from './components/tour/tour.module';
import { ScreenRecorderModule } from './components/screen-recorder/screen-recorder.module';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideVertexAI, getVertexAI } from '@angular/fire/vertexai-preview';
import { USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/compat/auth';
import { USE_EMULATOR as USE_FIRESTORE_EMULATOR } from '@angular/fire/compat/firestore';
import { USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/compat/functions';
import { USE_EMULATOR as USE_STORAGE_EMULATOR } from '@angular/fire/compat/storage';

register();

const f = environment.firebaseConfig;
const gtm = environment.gtm_id;

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        AngularFireModule.initializeApp(f),
        AppRoutingModule,
        FormsModule,
        UpdatePopupModule,
        FloatingThreadModule,
        TourModule,
        ScreenRecorderModule,
        PopoverModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        TimepickerModule.forRoot()
    ], providers: [
        AnalyticsService,
        UserManagementService,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideFirebaseApp(() => initializeApp(f)),
        provideVertexAI(() => getVertexAI()),
        provideCharts(withDefaultRegisterables()),
        provideHttpClient(withInterceptorsFromDi()),
        provideHttpClient(withFetch()),
        ...(environment.useEmulator
            ? [
                  { provide: USE_AUTH_EMULATOR, useValue: ['http://127.0.0.1:9099'] },
                  { provide: USE_FIRESTORE_EMULATOR, useValue: ['127.0.0.1', 8080] },
                  { provide: USE_FUNCTIONS_EMULATOR, useValue: ['http://127.0.0.1:5001'] },
                  { provide: USE_STORAGE_EMULATOR, useValue: ['127.0.0.1', 9199] },
              ]
            : [])
    ] 
})
export class AppModule { }
